import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      position: 'fixed',
      right: '0',
      top: '0',
      left: '280px',
      zIndex: 10,
      padding: '20px',
      background:
        'linear-gradient(180deg, #F1F7FF 80%, rgba(241, 247, 255, 0) 100%)',
      '@media (max-width: 1280px)': {
        left: '0'
      },
      '@media (max-width: 724px)': {
        justifyContent: 'flex-end'
      }
    },
    logo: {
      width: '80px',
      height: '80px'
    },
    container: {
      width: 'available',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    default: {
      height: 'min-content'
    },
    actuQuiz: {
      height: '350px'
    },
    MySkills: {
      height: '394px'
    },
    MyRank: {
      height: '411px'
    },
    MyClass: {
      height: '395.14px'
    },
    TableMyResult: {
      height: '283.65px'
    },
    TableMyNotes: {
      height: '320px'
    },
    AvatarChoiceBlock: {
      height: '800px'
    },
    AvatarChoiceBlockHeader: {
      marginTop: '10px'
    },
    AccountProfile: {
      height: '276px',
      '@media (max-width: 724px)': {
        height: '308px'
      }
    },
    FeatureClassManager: {
      height: '352px'
    },
    anim: {
      marginTop: '100px',
      marginBottom: '100px',
      marginLeft: 'auto',
      marginRight: 'auto',
      opacity: '0.5'
    },
    boxes: {
      height: 'calc(32px * 2)',
      width: 'calc(32px * 3)',
      position: 'relative',
      transformStyle: 'preserve-3d',
      transformOrigin: '50% 50%',
      marginTop: 'calc(32px * 1.5 * -1)',
      transform: 'rotateX(60deg) rotateZ(45deg) rotateY(0deg) translateZ(0px)'
    },
    box: {
      width: '32px',
      height: '32px',
      top: 0,
      left: 0,
      position: 'absolute',
      transformStyle: 'preserve-3d',
      '&:nth-child(1)': {
        transform: 'translate(100%, 0)',
        animation: '$box1 800ms linear infinite'
      },
      '&:nth-child(2)': {
        transform: 'translate(0, 100%)',
        animation: '$box2 800ms linear infinite'
      },
      '&:nth-child(3)': {
        transform: 'translate(100%, 100%)',
        animation: '$box3 800ms linear infinite'
      },
      '&:nth-child(4)': {
        transform: 'translate(200%, 0)',
        animation: '$box4 800ms linear infinite'
      },
      '& > div': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: '#5C8DF6',
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto',
        transform: 'rotateY(0deg) rotateX(0deg) translateZ(calc(32px / 2))',
        '&:nth-child(1)': {
          top: 0,
          left: 0
        },
        '&:nth-child(2)': {
          background: '#5C8DF6',
          filter: 'brightness(75%)',
          right: 0,
          transform: 'rotateY(90deg) translateX(12px) translateY(-16px)'
        },
        '&:nth-child(3)': {
          background: '#5C8DF6',
          filter: 'brightness(95%)',
          transform: 'rotateX(-90deg) translateY(12px) translateX(-16px)'
        },
        '&:nth-child(4)': {
          background: '#DBE3F4',
          top: 0,
          left: 0,
          transform: 'translateZ(calc(32px * 3 * -1))'
        }
      }
    },
    '@keyframes box1': {
      '0%,50%': {
        transform: 'translate(100%, 0)'
      },
      '100%': {
        transform: 'translate(200%, 0)'
      }
    },
    '@keyframes box2': {
      '0%': {
        transform: 'translate(0, 100%)'
      },
      '50%': {
        transform: 'translate(0, 0)'
      },
      '100%': {
        transform: 'translate(100%, 0)'
      }
    },
    '@keyframes box3': {
      '0%,50%': {
        transform: 'translate(100%, 100%)'
      },
      '100%': {
        transform: 'translate(0, 100%)'
      }
    },
    '@keyframes box4': {
      '0%': {
        transform: 'translate(200%, 0)'
      },
      '50%': {
        transform: 'translate(200%, 100%)'
      },
      '100%': {
        transform: 'translate(100%, 100%)'
      }
    },
    header: {
      marginBottom: '10px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
